<template>
  <van-field
    :value="date"
    :label="label"
    :rules="rules"
    :input-align="inputAlign"
    readonly
    clickable
    @click="visible=true"
  >
    <template #input>
      {{ formatData(date) }}
      <van-popup v-model="visible" position="bottom" get-container="body">
        <van-datetime-picker
          :value="currentDate"
          type="datetime"
          title="选择完整时间"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="visible=false"
          @confirm="onConfirm"
        />
      </van-popup>
    </template>
    <template #extra>
      <van-icon name="arrow-down" />
    </template>
  </van-field>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'WhFieldTimePopup',
  model: {
    prop: 'date',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: '选择'
    },
    emptyText: {
      type: String,
      default: '请选择时间'
    },
    date: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: undefined
    },
    inputAlign: {
      type: String,
      default: 'right'
    }
  },
  data() {
    return {
      visible: false,
      minDate: new Date(2021, 1, 1),
      maxDate: new Date()
    }
  },
  computed: {
    currentDate() {
      return dayjs(this.date ? this.date : undefined).toDate()
    }
  },
  methods: {
    formatData(val) {
      return val ? dayjs(val).format('YYYY-MM-DD HH:mm') : this.emptyText
    },
    onConfirm(val) {
      this.$emit('change', dayjs(val).format('YYYY-MM-DD HH:mm:00'))
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.van-icon-arrow-down {
  margin: 5px;
}
</style>
